import moment from 'moment';

import { PolicyTermsEnum } from '../enums/enums';
import { MONTHS } from '../../../timeConstants';

export function diffBetweenTwoDatesInMonths(startDate, endDate) {
  return moment(new Date(endDate)).diff(new Date(startDate), MONTHS, true);
}
export function sortWithQuantumLebenPriorityAndReturn(resultsArray) {
  resultsArray.sort((prevResult, nextResult) => {
    if (prevResult.policyTerms === PolicyTermsEnum.QL_MLB_06_2019 || prevResult.policyTerms > nextResult.policyTerms) {
      return -1;
    }
    if (prevResult.policyTerms < nextResult.policyTerms) {
      return 1;
    }

    return 0;
  });

  return resultsArray;
}
